(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("connectExternalLogin", {
        templateUrl: "app/account/externalLogin/connectExternalLoginView.html",
        controller: ["accountsResource", "$state", "$stateParams", "messageService", ConnectExternalLoginCtrl],
        controllerAs: "vm"
    });
    function ConnectExternalLoginCtrl(accountsResource, $state, $stateParams, messageService) {
        if (!$stateParams.loginProvider) {
            messageService.error("common.genericError");
            $state.go("main.myAccount", {}, { location: "replace" });
            return;
        }
        if (!$stateParams.providerKey) {
            messageService.error("common.genericError");
            $state.go("main.myAccount", {}, { location: "replace" });
            return;
        }
        accountsResource.addExternalLogin({
            loginProvider: $stateParams.loginProvider,
            providerKey: $stateParams.providerKey
        }, function () {
            messageService.success("common.success");
            $state.go("main.myAccount", {}, { location: "replace" });
        }, function (error) {
            messageService.error(error);
            $state.go("main.myAccount", {}, { location: "replace" });
        });
        //return true;
    }
}());
